import TableFunction from '../../../../../components/table/TableFunction';
import React, {useEffect, useState} from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import CustomChip from '../../../../../components/CustomChip';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';

import {
    DeleteIconsOptions,
    DetailsIconsOptions, QrCodeIcon,
    UpdateIconsOptions,
} from '../../../../../components/buttons/IconButtons';
import { ArrowRightIcon } from '@mui/x-date-pickers';
import { EXTRA_MEAL_TYPE_MODEL, REQUEST_STATUS } from '../Model/Models';
import routes from '../../../../../Routes/routes';
import {useDispatch, useSelector} from 'react-redux';
import { permissionObj } from '../../../../../Helpers/permission';
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat} from '../../../../../Apis/functions';
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../../enums/statusEnum";
import {
    GetExtraOrders,
    GetStatusByUserIdActive
} from "../../../../../reduxToolkit/FoodieExtraMeal/FoodieExtraMealApi";
import { FOODIE_REQUEST } from '../../Request/Model/Model';
import {TABS_FOODIE_ORDERS, SUB_VIEW_MODEL} from "../../../DiningOrders/Model/Models";
import {colors} from "../../../../../enums/colors";
import {useOutletContext} from "react-router-dom";


/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const ActiveTableApp = ({
    modified,
    setModified,
    setItemSelected,
    searchElement,
    setShowSummaryModal,
    setShowRequestModal,
    setExtraMealType,
    setDeleteMealRequestShow,
    handleDownload
}) => {
    // Initialize navigate function for routing
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const tableId = 'tbl_at_active';
    const searchId = 'txt_at_search_active';
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const [results, setResults] = useState(null);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const userId = user?.data?.id;
    const  statusDb  = useSelector((state) => state.FoodieExtraMealSlice.statusByUserIdActive);
    const { meal, setMeal } = useOutletContext();

    useEffect(() => {
        getStatuses();
    }, []);

    const getStatuses = () => {
        dispatch(GetStatusByUserIdActive({userId,  isHistory: false }));
    }

    // Same gate as the create button in the page header, so the empty state does
    // not offer an action the user cannot complete
    const canCreate = DEV || permission?.includes(permissionObj?.WEB_FOODIE_EXTRA_REQUEST_CREATE);

    // The modal branches on the type and does not let the user pick it, so the
    // empty state opens the personal flow; the header dropdown covers the rest
    const handleCreate = () => {
        setExtraMealType(EXTRA_MEAL_TYPE_MODEL.PERSONAL);
        setShowRequestModal(true);
    };

    const getThead = () => {
        return [
            <CustomTh tableId={tableId}>{t('serving_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('service_time')}</CustomTh>,
        ];
    };
    const getTbody = () => {
         if (!results || results?.content?.length === 0)
            return {
                body: [],
                data: [],
            };
        let body = results?.content.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId}>
                        {item?.servingDate ? getDateFormat(item.servingDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) : EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[item?.approvalStatusId]}
                            fontColor={statusFontColor[item?.approvalStatusId]}
                            borderColor={statusBorderColor[item?.approvalStatusId]}
                            legend={t(status[item?.approvalStatusId]) || EMPTY_VALUES.DEFAULT}
                            variant='large'
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.createdAt ? getDateFormat(item.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) : EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        { item?.mealTimeName ?
                            <CustomChip
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                legend={item?.mealTimeName}
                                variant={'compact'}
                            />
                            :
                            EMPTY_VALUES.DEFAULT
                        }
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: results?.content,
        };
    };

    const getActionsButtons = (item, index) => {
        if (!item) return null;

        // With view access only the request can be inspected, every other action manages it
        const canManageRequest = DEV
            || permission.includes(permissionObj?.WEB_FOODIE_EXTRA_REQUEST_UPDATE)
            || contractorId
            || supplierId;

        let goPath = '';
        let currentPath = '';
        if (contractorId) {
            goPath = routes.contractor.listMeals;
            currentPath = routes.contractor.foodie;
        } else if (supplierId) {
            goPath = routes.suppliers.listMeals;
            currentPath = routes.suppliers.foodie;
        } else {
            goPath = routes.foodieOrders.listMeals;
            currentPath = routes.foodieOrders.main;
        }

        return (
            <>
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item?.id}`}
                >
                    {(item.approvalStatusId === STATUS_MODEL.CHANGES_REQUESTED) && (
                        <DropDownMenuItem
                            key="update"
                            index={index}
                            handleClose={handleClose}
                            name={t('update')}
                            icon={<UpdateIconsOptions />}
                            click={() => {
                                setShowRequestModal(true);
                                setItemSelected(item);
                            }}
                        />
                    )}

                    {item.approvalStatusId === REQUEST_STATUS.APPROVED.id && canManageRequest && ([
                            <DropDownMenuItem
                                index={index}
                                handleClose={handleClose}
                                name={t('select')}
                                icon={<ArrowRightIcon />}
                                url={{
                                    pathname: `${goPath}`,
                                    state: {
                                        foodieRequestId: item?.id,
                                        servingDate: item?.servingDate,
                                        mealTimeId: item?.mealTimeId,
                                        backUrl:{
                                            pathname: currentPath,
                                            state: {
                                                currentTab: TABS_FOODIE_ORDERS.REQUEST_MEALS.INDEX,
                                                currentSubView: SUB_VIEW_MODEL.REQUEST_MEALS.ACTIVE
                                            }
                                        }
                                    }
                                }}
                                click={() => {
                                    const aux = meal.clear();
                                    setMeal({ ...aux});
                                }}
                            />,
                            <DropDownMenuItem
                                index={index}
                                handleClose={handleClose}
                                name={t('QR')}
                                icon={<QrCodeIcon />}
                                click={() => handleDownload(item.id)}
                            />
                        ]
                    )}

                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        icon={<DetailsIconsOptions />}
                        click={() => {
                            setShowSummaryModal(true);
                            setItemSelected(item);
                        }}
                    />

                    {(item.requestedById === null || item.requestedById === userId) &&
                        item.approvalStatusId === REQUEST_STATUS.PENDING_REVIEW.id &&
                        (DEV || permission.includes(permissionObj?.WEB_FOODIE_EXTRA_REQUEST_DELETE) || contractorId || supplierId) && (
                        <DropDownMenuItem
                            key="delete"
                            index={index}
                            handleClose={handleClose}
                            name={t('delete')}
                            fontColor="font-color-error-600"
                            iconColor={"icon-color-error-code-600"}
                            icon={<DeleteIconsOptions />}
                            click={() => {
                                setDeleteMealRequestShow(true);
                                setItemSelected(item);
                            }}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = {
            key: searchElement,
            searchType:FOODIE_REQUEST.USER_ACTIVE,
            pagination: {
                page,
                size: rowsPerPage,
            }
        };

        dispatch(GetExtraOrders(body)).then(({ payload:{ data: { data, success }} }) => {
            if (success) {
                setResults(data.value);
            }
        });
        getStatuses();
    }

    const {
        t,
        thead,
        tbody,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        handleCheckboxChange,
        rowsPerPage,
    } = TableFunction({
        data:results,
        labelRowsPerPage: 'request_per_page',
        getTbody,
        getThead,
        fixedPagination: false,
        hasContainer: true,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        tableId,
        searchId,
        tbody,
        thead,
        status:statusDb,
        getActionsButtons,
        handleCheckboxChange,
        pagination,
        results,
        setResults,
        canCreate,
        handleCreate
    };
};
export default ActiveTableApp;
